module.exports = __webpack_public_path__ + "21a7247084d85eee09b7068c55982c78.pdf";